<template>
  <div class="wrapper">
    <el-card class="box-card specials">
      <div class="nav_list">
        <el-form-item :label="'手续费返现设置'">
          <p class="item_title">序号</p>
          <p class="item_title">层级id</p>
          <p class="item_title">层级名称</p>
          <p class="item_title">返现上限</p>
          <p class="item_title">返现比例（%）</p>
        </el-form-item>
      </div>
      <div class="text" v-for="(card,index) in update.col.data">
        <div slot="header" class="clearfix titleCon">
          <div v-if="!readonly" class="btn-list">
            <el-button type="text" @click="addReward()">{{$t('crs.bt.add')}}</el-button>
            <el-button v-if="update.col.data.length > 1" type="text" @click="delReward(index)">{{$t('crs.bt.delete')}}</el-button>
          </div>
        </div>
        <div class="item">
          <div class="item-table">
            <el-form-item :label="String(index+1)" >
              <el-input-number class="item-select" controls-position="right"  v-model="card.levelId" :min="1"  :required="true" :placeholder="'层级id'" :disabled="readonly"></el-input-number>
              <el-input class="item-input" controls-position="right" v-model="card.name" :required="true" :disabled="readonly" :placeholder="'层级名称'"></el-input>
              <el-input-number class="item-select" controls-position="right" :min="0" v-model="card.limit"  :required="true" :placeholder="'返现上限'" :disabled="readonly"></el-input-number>
              <el-input-number class="item-select" controls-position="right" :min="0" v-model="card.ratio"  :required="true" :placeholder="'返现比例（%）'" :disabled="readonly"></el-input-number>
            </el-form-item>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
  export default {
    name: 'level',
    props:["update"],
    methods: {
        addReward(){
            this.update.col.data.push({levelId:this.update.col.data.length + 1});
        },
        delReward(index){
            this.update.col.data.splice(index, 1);
        },
    },
    computed:{
        readonly(){
            return (this.update.updateModel.id && this.update.updateModel.status != 4)?true:false;
        }
    },
    data () {
      return {
          taskList: [

          ],
      }
    }
  }
</script>
<style>
.nav_list .item_title{
  display: inline-block;
  float: left;
  width: 30.5%;
  margin-left: 3%;
}
.box-card.specials .text .item-table .item-select{
  overflow: hidden;
  width: 30%;
  margin-right: 1%;
}

</style>
